import { NextPageContext } from 'next';
import redirectToDomain from './redirectToDomain';
import getUrlFromRequest from './getUrlFromRequest';
import getPrefix from './getPrefix';
import hasNews from './hasNews';
import getWindowUrl from './getWindowUrl';
import { getTargetOrigin } from './redirectRouteToDomain';

const redirectToDomainByPrefix: Record<string, string> = {
  'fashionunited.ch/lavorare-nella-moda': 'fashionunited.ch',
  'fashionunited.ch/fashion-jobs': 'fashionunited.ch',
};

const redirectToNewsDomain = (path: string) => ({
  req, res,
}: NextPageContext) => {
  const url = req ? getUrlFromRequest(req) : getWindowUrl();
  const prefix = getPrefix(url);

  if (!hasNews(prefix)) {
    redirectToDomain(
      path,
      res,
      getTargetOrigin(
        url,
        redirectToDomainByPrefix[prefix] || 'fashionunited.com',
      ),
    );
  }

  return {};
};

export default redirectToNewsDomain;
